type FieldMeta = { errors?: unknown[] };

export function getFieldErrorCount(
  fieldMeta: Record<string, FieldMeta | undefined>,
  fieldName: string,
): number {
  return fieldMeta[fieldName]?.errors?.length ?? 0;
}
